module.exports = class LeftNav
  constructor: ->
    @$nav = $('#left-nav-categories')
    @$navUl = @$nav?.find('> ul')
    @$navList = @$navUl?.children()

    return unless @$navList.length

    @navHeight = @$nav.outerHeight()
    @navPadding = @$navUl.position().top
    @arrowTop = parseInt $(@$navList.find('.arrow')[0]).css('top')

    @displacementCache = []

    @setSubNavPosition()
    @enableSuvNav()

  setSubNavPosition: ->
    for nav in @$navList
      $nav = $(nav)
      $flyout = $nav.find('.left-nav-flyout')
      continue unless $flyout

      unless @subnavHeight and @subnavPadding
        $flyout.css {display: 'block', visibility: 'hidden'}
        @subnavHeight = $($flyout.find('li')[0]).outerHeight(true)
        $flyout.removeAttr('style')

      displacement = @calculateDisplacement
        top: $nav.position().top
        height: $flyout.outerHeight()
        arrowPosition: Math.floor(($flyout.find('ul:first').children().length) / 2) or 1
      @applyDisplacement $flyout, displacement

  calculateDisplacement: ({top, height, arrowPosition}) ->
    displacement = @displacementCache[arrowPosition]
    unless displacement
      displacement = (@subnavHeight - @arrowTop) * (1 - arrowPosition) - @arrowTop / 2
      @displacementCache[arrowPosition] = displacement

    return @navPadding - top if top + displacement < @navPadding
    return @navHeight - @navPadding - top - height if top + displacement + height > @navHeight - @navPadding
    displacement

  applyDisplacement: ($flyout, displacement) ->
    $flyout.css('top', "#{displacement}px")
    $flyout.find('.arrow').css('top', "#{(displacement * -1) + @arrowTop}px")

  enableSuvNav: ->
    @$nav.removeClass('flyout-disabled')
